<template>
  <div class="main-wrap no-padding">
    <div class="waybill-top" v-if="iconType === 1">
      <el-button type="primary" @click="exportOpen" :loading="enterLoading" icon="iconfont icondaochu" class="h40 exportOpen" plain>{{ $lang('导出') }}</el-button>
      <el-button icon="iconfont icondaochu" type="primary" @click="dialogExportDownVisible = true" class="h40" plain>{{ $lang('下载中心') }}</el-button>
    </div>
    <div class="top-search">
      <el-form :model="searchParam" ref="seach" :inline="true">
        <el-form-item>
          <el-button-group>
            <el-button type="primary" :id="[timeType === 0 && 'btnDay']" class="btnMonth" @click="typeChange(0)">{{$lang('按日')}}</el-button>
            <el-button type="primary" :id="[timeType === 1 && 'btnDay']" class="btnMonth" @click="typeChange(1)">{{$lang('按月')}}</el-button>
          </el-button-group>
        </el-form-item>
          <el-form-item prop="month">
            <span v-if="timeType === 1">
            <el-date-picker
              v-model="searchParam.month"
              type="month"
              value-format="yyyy-MM"
              :placeholder="$lang('选择月')">
            </el-date-picker>
          </span>
          </el-form-item>
          <el-form-item prop="date">
            <span v-if="timeType === 0">
              <el-date-picker
                :clearable="false"
                v-model="searchParam.date"
                type="daterange"
                :default-time="['00:00:00', '23:59:59']"
                :range-separator="$lang('至')"
                :start-placeholder="$lang('开始日期')"
                :end-placeholder="$lang('结束日期')"
                class="commonSize"
                @change="selectDate"
                value-format="yyyy-MM-dd HH:mm:ss"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </span>
          </el-form-item>
          <el-form-item props="orderAccounts" class="account-userId">
            <el-select v-model="searchParam.orderAccounts" multiple collapse-tags :placeholder="$lang('请选择下单账号')">
              <el-option
                v-for="item in accountOptions"
                :key="item.userId"
                :label="item.account"
                :value="item.account">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <span>
              <el-checkbox v-model="includeReturnFlag">{{$lang('包含退回件')}}</el-checkbox>
            </span>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="iconfont iconchaxun" class="h32" @click="queryChange">{{ $lang('查询') }} </el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="iconfont iconshanchu" class="h32" @click="resetSearch">{{ $lang('清空') }} </el-button>
          </el-form-item>
          <el-form-item>
            <el-button v-show="iconType === 0" type="primary" icon="iconfont iconliebiao" class="h32" @click="listAsIcon(1)">{{ $lang('列表模式') }} </el-button>
          </el-form-item>
          <el-form-item>
            <el-button v-show="iconType === 1" style="margin-left: -10px;" type="primary" icon="iconfont icontubiao" class="h32" @click="listAsIcon(0)">{{ $lang('图表模式') }} </el-button>
          </el-form-item>
        </el-form>
    </div>
    <div class="sub-main" v-show="iconType === 0">
      <div class="baseFunIcon">
        <div class="total-rt">
          <el-row>
            <el-col :span="8" v-for="(item, index) in totalRowData" :key="index" >
              <div style="display: inline;">
                <div>
                  <span class="num">{{item.signRate}}</span>
                  <span class="text">{{item.name}}</span>
                </div>
                <div>
                  <span class="numVal">{{item.deliverCount}}</span>
                  <span class="textVal">{{$lang('派件票数')}}</span>
                </div>
                <div>
                  <span class="numVal">{{item.signCount}}</span>
                  <span class="textVal">{{$lang('签收票数')}}</span>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="baseFunCheck">
        <div class="check-left">
          <div class="tabs">
            <div :class="[activeIndex === 1 ? 'active' : '', 'tab-btn']" @click="tabsHandler(1)">{{ $lang('省份排名') }}</div>
            <div :class="[activeIndex === 2 ? 'active' : '', 'tab-btn']" @click="tabsHandler(2)">{{ $lang('城市排名') }}</div>
          </div>
          <div class="tabs-content">
            <div class="header">
              <el-row>
                <el-col :span="5">{{ $lang('排名') }}</el-col>
                <el-col :span="9">{{ activeIndex === 1 ? $lang('省份排名') : $lang('城市排名') }}</el-col>
                <el-col :span="10">{{ $lang('签收率') }}</el-col>
              </el-row>
            </div>
            <div class="tables" v-loading="loading">
              <el-row v-for="(item, index) in countTopTenData" :key="index">
                <el-col :class="{ top: index < 3 }" :span="5">{{ index + 1 }}</el-col>
                <el-col class="province" :span="9">
                  <el-tooltip class="item" effect="dark" :content="activeIndex === 1?$lang(item.provName):$lang(item.cityName)" placement="top">
                    <div>{{ activeIndex === 1?$lang(item.provName):$lang(item.cityName) }}</div>
                  </el-tooltip>
                </el-col>
                <el-col :span="10">
                  <el-progress class="lines" color="#2d7cff" :percentage="parseFloat(item.signRate)"></el-progress>
                </el-col>
              </el-row>
              <div style="text-align: center; margin-top: 100px" v-if="!countTopTenData.length">
                {{ $lang('暂无数据') }}
              </div>
            </div>
          </div>
        </div>
        <div class="check-right">
          <div id="pillarId1" class="pillarStyle" />
        </div>
      </div>
    </div>
    <div class="addressManageContent main-wrap" >
      <div class="main-table">
            <JmsTable
              :option="listOpt"
              :data="tableList"
              :page="page"
              :table-loading="loading"
              @row-del="rowDel"
              @size-change="sizeChange"
              @selection-change="selectionChange"
              @current-change="currentChange"
            >
            <!-- 派件票数 -->
            <template slot="dispatchCount" slot-scope="data">
                <span @click="getDetailInfo('dispatchCount', data.row)" class="slotSty">{{ data.row.dispatchCount }}</span>
            </template>
            <template slot="dispatchSignCount" slot-scope="data">
                <span @click="getDetailInfo('dispatchSignCount', data.row)" class="slotSty">{{ data.row.dispatchSignCount }}</span>
            </template>
            <template slot="dispatchNsignCount" slot-scope="data">
                <span @click="getDetailInfo('dispatchNsignCount', data.row)" class="slotSty">{{ data.row.dispatchNsignCount }}</span>
            </template>
            <template slot="codCount" slot-scope="data">
                <span @click="getDetailInfo('codCount', data.row)" class="slotSty">{{ data.row.codCount }}</span>
            </template>
            <template slot="codSignCount" slot-scope="data">
                <span @click="getDetailInfo('codSignCount', data.row)" class="slotSty">{{ data.row.codSignCount }}</span>
            </template>
            <template slot="codNsignCount" slot-scope="data">
                <span @click="getDetailInfo('codNsignCount', data.row)" class="slotSty">{{ data.row.codNsignCount }}</span>
            </template>
            <template slot="noCodCount" slot-scope="data">
                <span @click="getDetailInfo('noCodCount', data.row)" class="slotSty">{{ data.row.noCodCount }}</span>
            </template>
            <template slot="noCodSignCount" slot-scope="data">
                <span @click="getDetailInfo('noCodSignCount', data.row)" class="slotSty">{{ data.row.noCodSignCount }}</span>
            </template>
            <template slot="noCodNsignCount" slot-scope="data">
                <span @click="getDetailInfo('noCodNsignCount', data.row)" class="slotSty">{{ data.row.noCodNsignCount }}</span>
            </template>
            </JmsTable>
      </div>
    </div>
    <!-- 导出订单弹框组件 -->
    <export-componet
      ref="exportComponet"
      :cityOptions="enterOptions"
      :exportVisible="exportVisible"
      :idsLength="selection.length"
      :exportData="exportData"
      @export-close="exportClose"
      @export-fn="exportFn"
    ></export-componet>

    <ExportDownloadDialog :moduleType="moduleType" :dialogExportDownVisible.sync="dialogExportDownVisible"></ExportDownloadDialog>
  </div>
</template>

<script>
import echarts from 'echarts'
import JmsTable from '@/components/jms-widget/jms-table'
import mixin from '@/mixins/mixin.js'
import { enterOptions, RESPONSE_SUCCESS } from '@constants'
import { getOrderCountTopTen, trendChart, getChart, reqReceiveList, asyExport, getSearchAccounts } from '@/api/module/customer'
import ExportDownloadDialog from '@components/export-download-dialog/ExportDownloadDialog.vue'
import exportComponet from '@components/base/BaseExport.vue'

export default {
  name: 'EnterPort',
  mixins: [mixin],
  components: {
    ExportDownloadDialog,
    JmsTable,
    exportComponet,
  },
  data () {
    let _minTime = null
    let _maxTime = null
    const maxTime = new Date(this.$taday.end).getTime()
    return {
      COM_HTTP: {
        reqList: reqReceiveList,
        // reqList: enterPortDel,
        reqExcel: asyExport,
      },
      searchParam: {
        date: this.$common.commonFun.GetTodayDate(),
        startTime: this.$common.commonFun.GetTodayDate()[0], // 开始时间，格式：yyyy-MM-dd HH:mm:ss
        endTime: this.$common.commonFun.GetTodayDate()[1], // 结束时间，格式：yyyy-MM-dd HH:mm:ss
        month: this.$common.commonFun.getProtMonth(), // 默认月
        includeReturn: 1,
        orderAccounts: [],
      },
      enterLoading: false,
      enterOptions: [],
      exportVisible: false, // 导出弹框显示
      exportData: {},
      dialogExportDownVisible: false, // 下载中心
      exportType: 2, // 1：订单； 2：运单
      moduleType: 'in_harbor', // 进港
      selection: [],
      page: {
        // 分页配置
        current: 1,
        size: 100,
        total: 0,
        sizes: [
          50,
          100,
          200,
          500,
          1000,
        ],
      },
      listLoading: false,
      includeReturnFlag: true,
      timeType: 0, // 日期切换
      iconType: 0, // 按钮切换
      activeIndex: 1,
      date: '',
      pickerOptions: {
        disabledDate (time) {
          if (_minTime && _maxTime) {
            return time.getTime() < _minTime || time.getTime() > _maxTime
          }
          return time.getTime() > maxTime
        },
        onPick ({ maxDate, minDate }) {
          // 如果选择了只选择了一个时间
          if (!maxDate) {
            const timeRange = 30 * 24 * 60 * 60 * 1000 // 31天
            _minTime = minDate.getTime() - timeRange // 最小时间
            _maxTime = minDate.getTime() + timeRange > new Date() ? maxTime : minDate.getTime() + timeRange// 最大时间
            // 如果选了两个时间，那就清空本次范围判断数据，以备重选
          } else {
            _minTime = _maxTime = null
          }
        },
      },
      xAxisData: [],
      seriesData: [],
      total: 0,
      countTopTenData: [],
      loading: false,
      totalRowData: [{ name: this.$lang('签收率') }, { name: this.$lang('COD签收率') }, { name: this.$lang('非COD签收率') }],
      accountOptions: [], // 下单账户列表
    }
  },
  computed: {
    // 用户信息
    userInfo () {
      return this.$store.state.base.user || {}
    },
    listOpt() {
      return {
        border: true,
        selection: false,
        menu: false,
        viewBtn: false,
        editBtn: false,
        delBtn: false,
        isShowFirst: false,
        // rowKey: '$index',
        column: [
          {
            label: '揽件日期',
            prop: 'deliverTime',
          },
          {
            label: '派件票数',
            prop: 'dispatchCount',
            slot: true,
          },
          {
            label: '签收票数',
            prop: 'dispatchSignCount',
            slot: true,
          },
          {
            label: '签收平均时长',
            prop: 'signHour',
          },
          {
            label: '待签收票数',
            prop: 'dispatchNsignCount',
            slot: true,
          },
          {
            label: '签收率',
            prop: 'dispatchRate',
            width: 60,
          },
          {
            label: 'COD揽收票数',
            prop: 'deliverCodCount',
            slot: true,
          },
          {
            label: 'COD签收票数',
            prop: 'codSignCount',
            slot: true,
          },
          {
            label: 'COD待签收票数',
            prop: 'codNsignCount',
            slot: true,
          },
          {
            label: 'COD签收率',
            prop: 'codSignRate',
          },
          {
            label: '非COD揽收票数',
            prop: 'noCodCount',
            slot: true,
          },
          {
            label: '非COD签收票数',
            prop: 'noCodSignCount',
            slot: true,
          },
          {
            label: '非COD待签收票数',
            prop: 'noCodNsignCount',
            width: 140,
            slot: true,
          },
          {
            label: '非COD签收率',
            prop: 'noCodSignRate',
          },
          {
            label: '下单账号',
            prop: 'orderAccount',
          },
        ],
      }
    },
  },
  mounted () {
    // const _this = this
    // console.log('_this.$refs.pieChart', _this.$refs.pieChart)
    // this.$nextTick(() => {
    //   window.onresize = function() {
    //     _this.$refs.pieChart.resize()
    //   }
    // })
    console.log('111111111111111>>')
    this.getOrderCountTopTen()
    this.trendChart()
    this.getChart()
    this.getAccountList()
  },
  methods: {
    // 获取账号列表
    async getAccountList() {
      const { code, data, msg } = await getSearchAccounts()
      console.log(code, data, msg, 'code, data, msg')
      if (code === RESPONSE_SUCCESS) {
        this.accountOptions = data
      } else {
        this.$message.error(msg)
      }
    },
    // TODO 测试数据
    testGenerateData () {
      let i = 0
      while (i < 30) {
        this.xAxisData.unshift(new Date(new Date().setDate(new Date().getDate() - i)).toLocaleDateString())
        const n = Math.floor(Math.random() * 9999999 + 1)
        this.seriesData.push(n)
        i++
      }
    },
    goPage (item) {
      this.$router.push({ path: `/${item.type}`, query: { ...item, ...this.searchParam }})
    },
    /**
     * 获取省份和城市Top
     * topType 1 省份  2 城市
     *
     */
    async getOrderCountTopTen (topType = 1) {
      try {
        this.loading = true
        var topPam = this.updatePam()
        topPam.topType = topType
        topPam.size = 10
        const res = await getOrderCountTopTen(topPam)
        this.loading = false
        if (res && res.succ) {
          this.countTopTenData = res.data.records
        }
      } catch (error) {
        this.loading = false
      }
    },
    // 获取图表和订单总量
    async trendChart () {
      try {
        const res = await trendChart(this.updatePam())
        // this.$refs.pieChart && this.$refs.pieChart.hideLoading()
        if (res && res.succ) {
          this.xAxisData = res.data.records ? res.data.records.map(({ hour }) => hour) : []
          this.seriesData = res.data.records ? res.data.records.map(({ signCount }) => signCount) : []
          console.log('xAxisData', this.xAxisData)
          this.initPillarChart1()
          this.total = res.data.total
        }
      } catch (error) {
        console.log(error)
        // this.$refs.pieChart && this.$refs.pieChart.hideLoading()
      }
    },

    /**
     * 去详情
     */
    getDetailInfo (type, obj) {
      var routePam = this.updatePam()
      routePam.detailType = type
      routePam.startTime_sum = routePam.startTime
      routePam.endTime_sum = routePam.endTime
      if (this.timeType === 1) {
        routePam.startTime = obj.queryTime
        routePam.endTime = obj.queryTime
      } else {
        routePam.startTime = obj.queryTime + ' ' + '00:00:00'
        routePam.endTime = obj.queryTime + ' ' + '23:59:59'
      }
      console.log('routePam', routePam)
      this.$router.push({ path: '/detailList', query: { ...routePam }})
    },

    // 获取
    async getChart() {
      try {
        const res = await getChart(this.updatePam())
        if (res && res.succ) {
          const data = res.data.records[0]
          // [{ name: this.$lang('签收率') }, { name: this.$lang('COD签收率') }, { name: this.$lang('非COD签收率') }]
          if (data) {
            for (var key in data) {
              if (key === 'dispatchRate') {
                this.totalRowData[0].signRate = data[key]
              } else if (key === 'dispatchCount') {
                this.totalRowData[0].deliverCount = data[key]
              } else if (key === 'dispatchSignCount') {
                this.totalRowData[0].signCount = data[key]
              } else if (key === 'codSignRate') {
                this.totalRowData[1].signRate = data[key]
              } else if (key === 'codCount') {
                this.totalRowData[1].deliverCount = data[key]
              } else if (key === 'codSignCount') {
                this.totalRowData[1].signCount = data[key]
              } else if (key === 'noCodSignRate') {
                this.totalRowData[2].signRate = data[key]
              } else if (key === 'noCodCount') {
                this.totalRowData[2].deliverCount = data[key]
              } else if (key === 'noCodSignCount') {
                this.totalRowData[2].signCount = data[key]
              }
            }
          }
          console.log('this.totalRowData', this.totalRowData)
          this.xAxisData = res.data.timeDatas ? res.data.timeDatas.map(({ time }) => time) : []
          this.seriesData = res.data.timeDatas ? res.data.timeDatas.map(({ quantity }) => quantity) : []
          this.total = res.data.total
        }
      } catch (error) {
        console.log(error)
      }
    },
    listAsIcon(val) {
      this.iconType = val
      if (val === 1) {
        this.searchFun(1)
      }
    },
    // 列表查询
    getCountBylist () {
      this.searchFun(1)
    },
    // 查询时间切换
    typeChange(val) {
      this.timeType = val
      if (val === 1) {
        this.searchParam.month = this.$common.commonFun.getProtMonth()
      } else {
        this.searchParam.month = ''
      }
    },
    formatNumber (str) {
      return this.$common.formatNumber(str)
    },
    resetSearch () {
      this.searchParam = {
        date: this.$common.commonFun.GetTodayDate(),
        startTime: this.$common.commonFun.GetTodayDate()[0],
        endTime: this.$common.commonFun.GetTodayDate()[1],
      }
    },
    queryChange () {
      if (this.iconType === 0) {
        const index = this.activeIndex === 1 ? 1 : 2
        this.getOrderCountTopTen(index)
        this.trendChart()
        this.getChart()
      } else {
        this.getCountBylist()
      }
    },
    // 选择日期
    selectDate () {
      if (this.searchParam.date) {
        const [start = '', end = ''] = this.searchParam.date
        this.searchParam.startTime = start
        this.searchParam.endTime = end
      }
    },
    tabsHandler (index) {
      this.activeIndex = index
      this.getOrderCountTopTen(index)
    },
    // 选择分页条数
    sizeChange (val, list) {
      this.page.current = 1
      this.page.size = val
      this.searchFun()
      this.selection = []
    },
    // 跳转页码
    currentChange(val) {
      this.page.current = val
      this.searchFun()
    },
    // 传参
    updatePam(flag) {
      const { month } = this.searchParam
      var params = Object.assign({}, this.searchParam)
      if (this.timeType === 1) {
        params.load_type = 'month'
        params.startTime = month
        params.endTime = month
      }
      if (flag === 10) {
        params.startTime_sum = params.startTime
        params.endTime_sum = params.endTime
      }
      params.includeReturn = this.includeReturnFlag ? 1 : 0
      params.current = this.page.current
      params.size = this.page.size
      console.log('888888', params)
      return params
    },

    getParams() {
      const resultPam = this.updatePam()
      var searchParam = Object.assign({}, resultPam)
      searchParam.current = this.page.current
      searchParam.size = this.page.size
      console.log(1111111111111, searchParam)
      return searchParam
    },
    // 折线图实例初始化1
    initPillarChart1() {
      this.pillarChartData = echarts.init(document.getElementById('pillarId1'))
      var option1 = {
        // grid: {
        //   top: 30,
        // },
        title: {
          z: 6,
          show: true,
          target: 'blank',
          subtarget: 'blank',
          left: 24,
          top: 17,
          backgroundColor: 'rgba(0,0,0,0)',
          borderColor: '#ccc',
          borderWidth: 0,
          padding: 5,
          itemGap: 10,
          text: this.$lang('签收票数走势'),
        },
        color: ['red'],
        tooltip: {
          trigger: 'axis'
          // formatter: formatter
        },
        legend: {
          data: ['中债国债到期收益率']
        },
        grid: {
          top: '10%',
          left: '3%',
          right: '4%',
          bottom: '2%',
          containLabel: true
        },
        // toolbox: {
        //   feature: {
        //     saveAsImage: {}
        //   }
        // },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.xAxisData,
          splitLine: {
            show: false, // 去掉网格线
          }
        },
        yAxis: {
          type: 'value',
          scale: true,
          axisLabel: {
            show: true,
            interval: 'auto'
            // formatter: '{value} %'// 纵坐标百分比
          },
          splitLine: {
            show: false, // 去掉网格线
          }
        },
        series: [
          {
            name: this.$lang('签收票数走势'),
            type: 'line',
            connectNulls: true,
            data: this.seriesData,
            itemStyle: {
              normal: {
                // areaStyle: { type: 'default', color: '#d5f0fd' }, // 设置线条区域颜色
                lineStyle: { color: 'red' } // 设置线条颜色
              }
            }
          }
        ]
      }

      this.pillarChartData.setOption(option1)
    },

    // 导出-获取参数
    getParamForOutExcel () {
      const sort = []
      const columnNames = []
      let ids = []
      // 获取选中行的数量
      const len = (this.selection && this.selection.length) || 0
      // 选中行ids处理（未选中不穿此参数）
      if (len) ids = this.selection.map(item => item.id)
      // 处理导出表格的属性字段
      this.columnList.forEach(item => {
        sort.push(item.key)
        columnNames.push(item.name)
      })
      let params = { ids, sort, columnNames, orderStatusCode: this.exportStatus }
      if (len) params = { ...params, ids }
      else {
        const exportPam = this.updatePam(10)
        params = { ...params, ...exportPam }
      }
      return params
    },

    // 打开导出弹框
    async exportOpen () {
      if (this.selection.length <= 0) {
        this.exportLoading = true
        this.searchFun()
        this.exportLoading = false
        const listTotal = this.tableList
        if (listTotal <= 0) {
          this.$message.warning(this.$lang('没有可导出的数据'))
          return
        }
        if (listTotal > 100000) {
          this.$message.warning(this.$lang('导出数量超过限制'))
          return
        }
      }
      this.enterOptions = [...enterOptions]
      // this.updateOutExcel(this.currentKey)
      this.exportVisible = true
      const exportData = {
        exportStatus: this.exportStatus,
        exportType: this.exportType, // 1：订单； 2：运单
      }
      this.exportData = exportData
    },
    // 关闭导出弹框
    exportClose (val) {
      this.exportVisible = val
    },
    // 导出数据
    async exportFn (status, data, dataParams) {
      this.exportVisible = status
      this.columnList = data
      this.excelParams = dataParams
      // 调用导出方法
      //   await this.outExcel()
      //   改为异步导出
      await this.asyExportWaybill()
    },
    async asyExportWaybill () {
      const param = this.getParamForOutExcel()
      // 调用导出api
      const { code, msg } = await this.COM_HTTP.reqExcel(param)
      if (code === RESPONSE_SUCCESS) {
        this.$message.success(this.$lang('导出成功，请前往下载中心查看'))
      } else {
        this.$message.error(this.$lang(msg))
      }
    },
  },

}
</script>

<style lang="scss" scoped>
.content .main-wrap {
  height: calc(100vh - 65px);
}
.top-search {
  padding: 16px 24px;
}
.sub-main {
  padding: 16px 24px 24px;
  background: #edeef3;
}
.baseHeader {
  height: 40px;
  line-height: 40px;
  font-weight: bold;
  padding-left: 24px;
  font-size: 16px;
  color: #333;
  border-bottom: 1px solid #eeeeee;
}
.baseFunIcon {
  padding: 24px;
  display: flex;
  background: #fff;
  height: 232px;
  min-width: 1200px;
  border-radius: 8px;
  .baseFunIconItem {
    padding: 25px 0;
    width: 142px;
    height: 92px;
    text-align: center;
    text-align: -webkit-center;
    border: 1px solid transparent;
    cursor: pointer;
    border-radius: 4px;
    &:hover {
      border-color: rgba(224, 189, 123, 0.3);
    }
    .warp {
      width: 60px;
      height: 60px;
      line-height: 60px;
      border-radius: 50%;
      text-align: center;
      background: rgba(224, 189, 123, 0.2);
      color: #e0bd7b;
      margin-bottom: 10px;
    }
    .text {
      color: #999999;
      font-size: 12px;
    }
    .iconfont {
      font-size: 24px;
    }
  }
}
#btnDay {
  background: rgba(230,0,18,0.10);
  border: 1px solid #e60012;
  color: #E60012;
  border-right: 1px solid #e60012;
  z-index: 10;
}
.btnMonth {
  width: 72px;
  height: 32px;
  background: #ffffff;
  color: #dddddd;
  border: 1px solid #dddddd;
}
.border-rb {
  border-right: 1px solid #dcdee1;
  border-bottom: 1px solid #dcdee1;
}
.border-rt {
  border-right: 1px solid #dcdee1;
}
.border-bt {
  border-bottom: 1px solid #dcdee1;
}
.total-lf {
  flex: 0 0 360px;
  margin-right: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  &:hover {
    background: #edeef3;
  }
  .num {
    font-size: 56px;
    font-family: PingFangSC, PingFangSC-Semibold;
    font-weight: 600;
    text-align: left;
    color: #e60012;
    line-height: 68px;
  }
  .text {
    font-size: 24px;
    font-family: PingFangSC, PingFangSC-Semibold;
    font-weight: 600;
    text-align: left;
    color: #333333;
    line-height: 30px;
    margin-top: 24px;
  }
}
.waybill-top {
  padding: 16px 0 0 24px;
}
.total-rt {
  flex: 1;
  .el-col-8 {
    // width: 33.33% !important;
    div {
      float: left;
      display: flex;
      float: left;
      flex-direction: column;
      padding-left: 20px;
      justify-content: center;
      height: 184px;
      cursor: pointer;
      &:hover {
        background: #edeef3;
      }
      .num {
        width: 148px;
        height: 48px;
        font-size: 35px;
        font-family: PingFangSC, PingFangSC-Semibold;
        font-weight: 600;
        text-align: left;
        color: #e60012;
        line-height: 48px;
      }
      .text {
        margin-top: 16px;
        width: 148px;
        height: 24px;
        font-size: 20px;
        font-family: PingFangSC, PingFangSC-Semibold;
        font-weight: 600;
        text-align: left;
        color: #333333;
        line-height: 24px;
      }
      .numVal {
        width: 80px;
        height: 24px;
        font-size: 20px;
        font-family: PingFangSC, PingFangSC-Semibold;
        font-weight: 600;
        text-align: left;
        color: #333333;
        line-height: 24px;
      }
      .textVal {
        margin-top: 16px;
        width: 80px;
        height: 18px;
        font-size: 14px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: left;
        color: #666666;
        line-height: 18px;
      }
    }
  }
}
.pillarStyle {
    height: 600px;
    width: 100%;
    background-color:#fff;
    // padding: 20px 0 0 20px;
    // ::v-deep div {
    //   width: 962px !important;
    // }
  }
.addressManageContent {
  .main-table{
     padding: 12px 24px;
    background: #edeef3;
    flex: 1;
        display: flex;
        flex-direction: column;
  }
  .searchParam {
    display: inline-flex;
    width: 100%;
    position: relative;
    margin-top: 10px;
    .searchParamInput {
      padding-right: 16px;
    }
    .el-button {
      height: 32px;
    }
    .addAddress {
      position: absolute;
      right: 0;
      height: 32px;
    }
  }
  .dot.oragin::before {
    width: 8px;
    height: 8px;
    background: #e60012;
  }
  /*.dot.green::before {*/
  /*  background: #52C41A;*/
  /*}*/
  .el-dialog {
    .el-dialog__body {
      .myDetail {
        display: inline-flex;
        padding: 0 0 24px 0;
        .myDetailItem {
          width: 200px;
          padding: 0 8px;
          .myDetailItemText {
            padding-bottom: 4px;
          }
        }
      }
      .addressDeatil {
        .el-input{
             width: 360px !important;
        }
      }
    }
    .reuqire {
      color: red;
    }
    .el-dialog__header {
      padding: 12px 25px !important;
      border-bottom: 1px solid #eeeeee;
    }
  }
}
.baseFunCheck {
  margin-top: 16px;
  display: flex;
  height: 642px;
  width: 100%;
  .check-left {
    margin-right: 16px;
    flex: 0 0 696px;
    background: #fff;
    border-radius: 8px;
    .tabs {
      display: flex;
      align-items: center;
      font-size: 16px;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      text-align: left;
      color: #333333;
      line-height: 20px;
      padding: 17px 24px;
      border-bottom: 1px solid #d8d8d8;
      .tab-btn {
        margin-right: 40px;
        cursor: pointer;
        &.active {
          position: relative;
          font-size: 18px;
          font-weight: 600;
          line-height: 22px;
          &::before {
            content: '';
            position: absolute;
            bottom: -17px;
            width: 24px;
            height: 3px;
            background: #e60012;
            border-radius: 2px;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
    }
    .tabs-content {
      .header {
        .el-row {
          font-size: 12px;
          font-family: PingFangSC, PingFangSC-Regular;
          font-weight: 400;
          text-align: left;
          color: #666666;
          line-height: 16px;
          padding: 12px 0;
          border-bottom: 1px solid #d8d8d8;
          .el-col-5 {
            padding-left: 48px;
          }
          .el-col-10 {
            padding-left: 7px;
          }
        }
      }
      .tables {
        font-size: 14px;
        font-family: ArialMT, ArialMT-Regular;
        font-weight: 400;
        text-align: left;
        color: #333333;
        line-height: 18px;
        .el-row {
          padding: 15px 0;
          .el-col-5 {
            padding-left: 48px;
            position: relative;
            &.top {
              position: relative;
              &::before {
                content: 'TOP';
                position: absolute;
                left: 13px;
                top: 50%;
                transform: translateY(-50%);
                width: 32px;
                height: 14px;
                background: #e60012;
                border-radius: 7px;
                font-size: 10px;
                font-family: PingFangSC, PingFangSC-Regular;
                font-weight: 400;
                text-align: center;
                color: #ffffff;
                line-height: 14px;
              }
            }
          }
          .province .el-tooltip {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .lines {
            ::v-deep .el-progress-bar{
              width: 90%;
            }
          }

          // .order-th {
          //   display: flex;
          //   align-items: center;
          //   padding-left: 7px;
          //   ::v-deep .lines {
          //     margin-right: 8px;
          //     width: 100px;
          //     height: 8px;
          //     // background: linear-gradient(270deg, #59b3ff, #2d7cff);
          //     border-radius: 5px;
          //     .el-progress-bar__outer {
          //       height: 8px !important;
          //       border-radius: 5px;
          //       .el-progress-bar__inner {
          //         background: linear-gradient(270deg, #59b3ff, #2d7cff);
          //       }
          //     }
          //   }
          // }
        }
      }
    }
  }
  .check-right {
    flex: 1;
    background: #fff;
    border-radius: 8px;
    .echarts {
      width: 100%;
      height: calc(100% - 41px);
    }

    .check-right-hd {
      overflow: hidden;
      ul {
        overflow: hidden;
        padding: 0;
        float: right;
        list-style: none;
        font-size: 12px;
        font-weight: normal;
        margin: 0;
        li {
          float: left;
          color: #666;
          margin-right: 10px;
        }
        .active {
          color: #e0bd7b;
        }
      }
    }
  }
}
.slotSty {
  color: #E60012;
  font-size: 12px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: left;
  line-height: 12px;

}
@media (max-width: 1400px) {
  .baseFunCheck {
    .check-right {
      .echarts {
        max-width: 100%;
        width: 100%;
      }
    }
  }
}
</style>

<style lang="scss">
.account-userId {
  .el-input__inner, input {
    max-height: 34px;
  }
  .el-select__tags {
    height: 30px;
    overflow: hidden;
  }
}
</style>
